import * as React from 'react';
import { SvgIcon } from '@material-ui/core';

const Account = props => {
  return (
    <SvgIcon {...props} width="32" height="32" viewBox="0 0 32 32">
      <g transform="translate(0 0.228)">
        <circle
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeMiterlimit={10}
          strokeWidth={2}
          cx="15"
          cy="15"
          r="15"
          transform="translate(1 0.772)"
        />
        <rect fill="none" width="32" height="32" transform="translate(0 -0.228)" />
        <path
          fill="#fff"
          opacity={0.64}
          d="M22.18,25.28a26.282,26.282,0,0,1-.057-2.677A5.239,5.239,0,0,0,23.559,19.5c.365-.03.94-.386,1.109-1.792a1.312,1.312,0,0,0-.49-1.313c.594-1.786,1.827-7.311-2.281-7.882-.423-.743-1.506-1.118-2.913-1.118-5.629.1-6.308,4.251-5.074,9a1.315,1.315,0,0,0-.49,1.313c.169,1.406.744,1.762,1.109,1.792A5.228,5.228,0,0,0,16,22.6a26.287,26.287,0,0,1-.058,2.677c-.8,2.155-4.919,2.324-7.294,4.4A15.545,15.545,0,0,0,19.4,33.972c4.247,0,9.239-3.353,10.07-4.268C27.111,27.606,22.984,27.443,22.18,25.28Z"
          transform="translate(-3.149 -2.659)"
        />
      </g>
    </SvgIcon>
  );
};

export default Account;
